import { render } from "./ActivityLogList.vue?vue&type=template&id=ec494536"
import script from "./ActivityLogList.vue?vue&type=script&lang=js"
export * from "./ActivityLogList.vue?vue&type=script&lang=js"

import "./ActivityLogList.vue?vue&type=style&index=0&id=ec494536&lang=css"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__